import { motion, useReducedMotion } from 'motion/react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { SITE } from '@/lib/site'

/*
  Base: "FAQ Accordion" de scrollxui (21st.dev), instalado e adaptado — mesma
  entrada palavra por palavra do título e mesma escada nos itens, com as três
  perguntas que decidem a compra e o acordeão do próprio projeto.
*/

const FAQS = [
  {
    question: 'A consulta grátis pede conta?',
    answer:
      'Não. Você digita a placa e vê os dados do veículo na hora, sem cadastro e sem senha.',
  },
  {
    question: 'O pagamento sai do site?',
    answer:
      'Não, o PIX abre na mesma tela. O QR Code aparece na própria página da placa e ela atualiza sozinha quando o pagamento cai.',
  },
  {
    question: 'Por quanto tempo o relatório fica disponível?',
    answer: '90 dias, no e-mail informado no pagamento.',
  },
]

const TITLE = 'Perguntas rápidas'

export function HomeFaq() {
  const reduce = useReducedMotion()
  const words = TITLE.split(' ')

  return (
    <section className="relative w-full overflow-hidden py-20">
      <div className="mx-auto max-w-3xl px-4">
        <h2 className="relative z-10 mx-auto text-center text-3xl font-bold tracking-tight text-foreground md:text-4xl">
          {words.map((word, index) => (
            <motion.span
              key={`${word}-${index}`}
              initial={reduce ? false : { opacity: 0, filter: 'blur(6px)', y: 12 }}
              whileInView={{ opacity: 1, filter: 'blur(0px)', y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.08, ease: 'easeInOut' }}
              className="mr-2 inline-block"
            >
              {word}
            </motion.span>
          ))}
        </h2>

        <motion.p
          initial={reduce ? false : { opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="relative z-10 mx-auto mt-5 max-w-2xl text-center text-base text-muted-foreground"
        >
          Ficou alguma dúvida? Escreva para{' '}
          <a
            href={`mailto:${SITE.supportEmail}`}
            className="font-medium text-brand underline underline-offset-4 hover:text-brand-dark"
          >
            {SITE.supportEmail}
          </a>
        </motion.p>

        <motion.div
          initial={reduce ? false : { opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="mt-12 rounded-xl border border-border bg-background px-5"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, index) => (
              <motion.div
                key={item.question}
                initial={reduce ? false : { opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: 0.5 + index * 0.07, ease: 'easeOut' }}
              >
                <AccordionItem value={`faq-${index}`}>
                  <AccordionTrigger>{item.question}</AccordionTrigger>
                  <AccordionContent>{item.answer}</AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  )
}
